@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (autoSaveLoading) {
  <div class="autosave-icon-fixed">
    <mat-icon class="blink">cloud_upload</mat-icon>
  </div>
}

@if (survey) {
  <div class="row" style="background-color: #F1F2F2">
    <div [class]="isAnonymous ? 'container-fluid px-0' : 'container mt-3'" [style.background-color]="isAnonymous ? 'white' : '#F1F2F2'">
      @if (survey?.answered && !justSubmitted && !isAnonymous) {
        <div class="alert alert-info my-3 text-center" role="alert">
          {{ (answerStatus === 'SENT' ? 'generic.questionnaire-sent' : 'components.responses.info-draft-date') | translate }}
          @if (answerTimestamp) {
            @let formattedDate = answerTimestamp | formatdate | date:'short';
            @if (answerStatus !== 'SENT') {
              {{ formattedDate }}
            } @else {
              <br>
              <span>
          {{ 'components.responses.info-sent-date' | translate }} {{ formattedDate }}
        </span>
            }
          }
        </div>
      }
    @if ((!survey?.answered && !impersonateEmail) || justSubmitted) {
      <mat-stepper [linear]="true" #stepper
        style="background-color: #F1F2F2">
        <!-- Anagraphic Form Template -->
        <ng-template #anagraphicFormContent>
          <form [formGroup]="userInfoForm" class="anagraphic-form-container card border-0 shadow-sm p-4 p-md-5 rounded-lg bg-white">
            <div class="row">
              <div class="col-12 col-md-6 mb-2">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>{{ "generic.name" | translate }}</mat-label>
                  <input formControlName="first_name" [(ngModel)]="survey.user.first_name"
                    [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6 mb-2">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>{{ "generic.surname" | translate }}</mat-label>
                  <input formControlName="last_name" [(ngModel)]="survey.user.last_name"
                    [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6 mb-2">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>{{ "generic.phone" | translate }}</mat-label>
                  <input formControlName="phone_number" [(ngModel)]="survey.user.phone_number" matInput>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6 mb-2">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>{{ "generic.email" | translate }}</mat-label>
                  <input type="email" [email]="true" [(ngModel)]="survey.user.email" formControlName="email"
                    [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
                </mat-form-field>
              </div>

              @for (field of survey.team_member_custom_fields; track field.id) {
                @if (field.visible) {
                  <div class="col-12 col-md-6 mb-2">
                    <mat-form-field appearance="fill" class="w-100">
                      <mat-label>{{ field.name }}</mat-label>
                      @switch (field.type) {
                        @case ('number') {
                          <input type="number" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                        }
                        @case ('date') {
                          <input type="date" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                        }
                        @case ('boolean') {
                           <mat-select [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]">
                              <mat-option [value]="true">{{ 'generic.yes' | translate }}</mat-option>
                              <mat-option [value]="false">{{ 'generic.no' | translate }}</mat-option>
                           </mat-select>
                        }
                        @default {
                          <input type="text" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                        }
                      }
                    </mat-form-field>
                  </div>
                }
              }
            </div>

            @if (survey?.visibility_type === 'PUBLIC' && !userService.userInfo) {
              @let isPrivacyInvalid = userInfoForm.get('privacy_accepted')?.invalid && userInfoForm.get('privacy_accepted')?.touched;
              <div class="privacy-box p-3 mt-3 rounded border" [class.privacy-invalid]="isPrivacyInvalid">
                <mat-checkbox formControlName="privacy_accepted" [disabled]="privacyAlreadyAccepted" [class.is-invalid]="isPrivacyInvalid">
                  <span [class.text-danger]="isPrivacyInvalid" class="font-weight-medium">
                    {{ "pages.surveys.response.privacy-acceptance" | translate }}
                  </span>
                </mat-checkbox>
                @if (privacyDocuments.length) {
                  <ul class="privacy-documents-list mb-0 mt-1">
                    @for (doc of privacyDocuments; track doc.id) {
                      <li>
                        <a [href]="doc.link" target="_blank" class="text-primary font-weight-bold">
                          {{ doc.name || ("pages.surveys.response.privacy-policy" | translate) }}
                        </a>
                      </li>
                    }
                  </ul>
                } @else {
                  <div class="mt-1 ml-4">
                    <span [class.text-danger]="isPrivacyInvalid" class="font-weight-bold">
                      ({{ "pages.surveys.response.privacy-policy" | translate }})
                    </span>
                  </div>
                }
                @if (isPrivacyInvalid) {
                  <small class="text-danger d-block mt-2 font-weight-bold">
                    <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: text-bottom;">error</mat-icon>
                    {{ "pages.surveys.response.privacy-mandatory" | translate }}
                  </small>
                }
                @if (privacyAlreadyAccepted) {
                  <small class="text-success d-block mt-2 font-weight-medium">
                    <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: text-bottom;">check_circle</mat-icon>
                    {{ "pages.surveys.response.privacy-already-accepted" | translate }}
                  </small>
                }
              </div>
            }
          </form>
        </ng-template>
        <!-- START: Anagraphic Form Step -->
        @if (shouldShowAnagraphicAt('START')) {
          <mat-step [stepControl]="userInfoForm">
            <ng-template matStepLabel>{{ "generic.generic-info" | translate }}</ng-template>
            <div class="card border-0 shadow-sm p-4 p-md-5 rounded-lg bg-white step-card mt-4 mb-4">
              <ng-container *ngTemplateOutlet="anagraphicFormContent"></ng-container>
              <div class="row justify-content-end mt-4 mx-1">
                <button class="btn-custom border-0 d-flex align-items-center px-5 py-2"
                [disabled]="loading || checkingPrivacy"
                (click)="validateAnagraphicAndProceed(stepper)">
                @if (checkingPrivacy) {
                  <mat-spinner diameter="18" class="mr-2 white-spinner"></mat-spinner>
                } @else {
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                }
                  {{'generic.next' | translate}}
                </button>
              </div>
            </div>
          </mat-step>
        }
        <!-- Intro Step: skipped entirely when there's nothing to show (no description and no attachments) -->
        @if (!survey?.customs?.skip_introduction && (hasValidDescription(survey?.description) || survey?.attachments?.length > 0)) {
          <mat-step>
            <ng-template matStepLabel>{{ "generic.introduction" | translate }}</ng-template>
            <div class="card border-0 shadow-sm p-4 p-md-5 rounded-lg bg-white step-card mt-4 mb-4">
              @if (hasValidDescription(survey?.description)) {
<!--                <p class="label-box font-weight-bold mt-4 mb-2">{{ "generic.description" | translate}}</p>-->
                <app-formatted-text-preview class="d-block mb-4" [content]="survey?.description"></app-formatted-text-preview>
              }
              @if (survey?.attachments?.length > 0) {
                <div class="mt-4 mb-4">
                  <app-attachments-list [attachments]="survey?.attachments" />
                </div>
              }
              <div class="row justify-content-end mt-4">
                <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" matStepperNext>
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{'generic.next' | translate}}
                </button>
              </div>
            </div>
          </mat-step>
        }
        <!-- Questions Step -->
        <mat-step [label]="'generic.questions' | translate" [completed]="isQuestionsValid">
          <div class="step-card mt-4 mb-4">
            <app-survey-details [surveyObj]="survey" [isResponse]="true" />
            @if (loading) {
              <div class="row my-4">
                <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
              </div>
            }
            <div class="card border-0 shadow-sm p-3 p-md-4 rounded-lg bg-white mt-4">
              <div class="row justify-content-between align-items-center m-0">
                <button [disabled]="loading" mat-stroked-button
                  class="text-dark-purple border-purple back-btn-stroked d-flex align-items-center"
                  matStepperPrevious>
                  {{'generic.back' | translate}}
                </button>
                @if (survey?.customs?.draft_answer_is_enabled) {
                  <button [disabled]="loading"
                    class="btn-custom border-0 d-flex align-items-center px-5 py-2 ml-auto mr-3"
                    (click)="!loading ? onSubmit(true) : ''">
                    {{'generic.buttons.save-draft' | translate}}
                  </button>
                }
                <!-- Submit Button (if Anagraphic is START or PRIVATE) -->
                @if (shouldShowAnagraphicAt('START') || survey.visibility_type === 'PRIVATE') {
                  <button [disabled]="loading"
                    class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="!loading ? onSubmit() : ''">
                    <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                    {{'generic.buttons.save-and-send' | translate}}
                  </button>
                } @else {
                  <!-- Next Button (if Anagraphic is END) -->
                  <button
                    class="btn-custom border-0 d-flex align-items-center px-5 py-2"
                    (click)="validateQuestionsAndProceed(stepper)">
                    <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                    {{'generic.next' | translate}}
                  </button>
                }
              </div>
            </div>
          </div>
        </mat-step>
        <!-- END: Anagraphic Form Step -->
        @if (shouldShowAnagraphicAt('END')) {
          <mat-step [stepControl]="userInfoForm">
            <ng-template matStepLabel>{{ "generic.generic-info" | translate }}</ng-template>
            <div class="card border-0 shadow-sm p-4 p-md-5 rounded-lg bg-white step-card mt-4 mb-4">
              <ng-container *ngTemplateOutlet="anagraphicFormContent"></ng-container>
              <div class="row justify-content-between mt-4 mx-1">
                <button mat-stroked-button
                  class="text-dark-purple border-purple back-btn-stroked d-flex align-items-center"
                  matStepperPrevious>
                  {{'generic.back' | translate}}
                </button>
                <button [disabled]="loading" class="btn-custom border-0 d-flex align-items-center px-5 py-2"
                  (click)="!loading ? onSubmit() : ''">
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{'generic.buttons.save-and-send' | translate}}
                </button>
              </div>
            </div>
          </mat-step>
        }
        <mat-step>
          <ng-template matStepLabel>{{ 'generic.done' | translate }}</ng-template>
          <div class="card border-0 shadow-sm p-4 p-md-5 rounded-lg bg-white step-card mt-4 mb-4 text-center d-flex flex-column align-items-center">
            <img src="assets/img/all-sent.png" alt="" class="all-sent-img mb-3">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 text-center color-primary-purple">
              {{ 'pages.surveys.response.submitted-successfully' | translate }}
            </h4>
          </div>
        </mat-step>
      </mat-stepper>
    }
    @if (survey?.answered && !justSubmitted) {
      <div class="anonymous-summary-container container-fluid py-4 px-md-5">

        <!-- Summary Dashboard: Always for Anonymous OR for Non-Anonymous DRAFTS -->
        @if (isAnonymous || answerStatus === 'DRAFT') {
            <!-- Centered Completion Badge -->
            <div class="d-flex justify-content-center mb-5">
                <div class="px-4 py-2 bg-light-purple color-primary-purple rounded-pill h5 mb-0 font-weight-bold shadow-sm border border-white">
                    {{ (answeredQuestions.length / survey.questions.length * 100) | number:'1.0-0' }}% {{ 'generic.completion' | translate }}
                </div>
            </div>

            <!-- Metrics Dashboard -->
            <div class="row mb-5">
                <div class="col-4">
                    <div class="card border-0 shadow-sm rounded-lg text-center p-3 border-bottom-success h-100">
                        <mat-icon class="text-success mb-2">check_circle_outline</mat-icon>
                        <div class="h3 font-weight-bold text-success mb-1">{{ answeredQuestions.length }}</div>
                        <div class="text-uppercase text-muted letter-spacing-1 x-small font-weight-bold">{{ 'generic.answered' | translate }}</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="card border-0 shadow-sm rounded-lg text-center p-3 border-bottom-warning h-100">
                        <mat-icon class="text-warning mb-2">pending</mat-icon>
                        <div class="h3 font-weight-bold text-warning mb-1">{{ partialQuestions.length }}</div>
                        <div class="text-uppercase text-muted letter-spacing-1 x-small font-weight-bold">{{ 'generic.partial' | translate }}</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="card border-0 shadow-sm rounded-lg text-center p-3 border-bottom-danger h-100">
                        <mat-icon class="text-danger mb-2">highlight_off</mat-icon>
                        <div class="h3 font-weight-bold text-danger mb-1">{{ missingQuestions.length }}</div>
                        <div class="text-uppercase text-muted letter-spacing-1 x-small font-weight-bold">{{ 'generic.missing' | translate }}</div>
                    </div>
                </div>
            </div>

            <!-- Question Breakdown (Details List) -->
            <div class="questions-breakdown" [class.mb-5]="!isAnonymous">
                <div class="d-flex align-items-center mb-3">
                    <div class="bg-primary-purple rounded" style="width: 4px; height: 20px;"></div>
                    <h6 class="mb-0 ml-2 text-uppercase x-small font-weight-bold text-muted letter-spacing-1">{{ 'generic.questions_details' | translate }}</h6>
                </div>

                <mat-accordion class="clean-accordion shadow-none">
                    @if (missingQuestions.length > 0) {
                        <mat-expansion-panel class="mb-2 border-left-danger shadow-sm" [expanded]="isAnonymous">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-danger font-weight-bold small">{{ 'generic.missing' | translate }} ({{ missingQuestions.length }})</mat-panel-title>
                            </mat-expansion-panel-header>
                            @for (q of missingQuestions; track q.id) {
                                <div class="d-flex flex-column py-2 px-1 border-bottom-light">
                                    <div class="d-flex align-items-center mb-1">
                                        <mat-icon class="text-danger mr-2" style="font-size: 16px; width:16px; height:16px;">close</mat-icon>
                                        <span class="small font-weight-bold">{{ q.question }}</span>
                                    </div>
                                    <div class="ml-4 d-flex flex-wrap">
                                        @for (step of getQuestionCompletionSteps(q); track step.label) {
                                            <div class="mr-3 mb-1 d-flex align-items-center x-small">
                                                <mat-icon [class]="step.status ? 'text-success' : 'text-muted'" style="font-size: 12px; width:12px; height:12px;" class="mr-1">
                                                    {{ step.status ? 'check_circle' : 'radio_button_unchecked' }}
                                                </mat-icon>
                                                <span [class.text-muted]="!step.status">
                                                    {{ step.label | translate }}{{ step.detail ? ': ' + step.detail : '' }}
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </mat-expansion-panel>
                    }

                    @if (partialQuestions.length > 0) {
                        <mat-expansion-panel class="mb-2 border-left-warning shadow-sm" [expanded]="isAnonymous">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-warning font-weight-bold small">{{ 'generic.partial' | translate }} ({{ partialQuestions.length }})</mat-panel-title>
                            </mat-expansion-panel-header>
                            @for (q of partialQuestions; track q.id) {
                                <div class="d-flex flex-column py-2 px-1 border-bottom-light">
                                    <div class="d-flex align-items-center mb-1">
                                        <mat-icon class="text-warning mr-2" style="font-size: 16px; width:16px; height:16px;">hourglass_empty</mat-icon>
                                        <span class="small font-weight-bold">{{ q.question }}</span>
                                    </div>
                                    <div class="ml-4 d-flex flex-wrap">
                                        @for (step of getQuestionCompletionSteps(q); track step.label) {
                                            <div class="mr-3 mb-1 d-flex align-items-center x-small">
                                                <mat-icon [class]="step.status ? 'text-success' : 'text-danger'" style="font-size: 12px; width:12px; height:12px;" class="mr-1">
                                                    {{ step.status ? 'check_circle' : (step.required !== false ? 'error_outline' : 'radio_button_unchecked') }}
                                                </mat-icon>
                                                <span [class.text-danger]="!step.status && step.required !== false" [class.text-muted]="!step.status && step.required === false">
                                                    {{ step.label | translate }}{{ step.detail ? ': ' + step.detail : '' }}
                                                </span>
                                            </div>
                                        }
                                    </div>
                                    @if (getQuestionValidationMessage(q)) {
                                        <div class="text-muted x-small mt-1 ml-4 italic">
                                            {{ getQuestionValidationMessage(q) | translate }}
                                        </div>
                                    }
                                </div>
                            }
                        </mat-expansion-panel>
                    }

                    @if (answeredQuestions.length > 0) {
                        <mat-expansion-panel class="mb-2 border-left-success shadow-sm">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-success font-weight-bold small">{{ 'generic.answered' | translate }} ({{ answeredQuestions.length }})</mat-panel-title>
                            </mat-expansion-panel-header>
                            @for (q of answeredQuestions; track q.id) {
                                <div class="d-flex flex-column py-2 px-1 border-bottom-light">
                                    <div class="d-flex align-items-center mb-1">
                                        <mat-icon class="text-success mr-2" style="font-size: 16px; width:16px; height:16px;">check</mat-icon>
                                        <span class="small font-weight-bold text-muted">{{ q.question }}</span>
                                    </div>
                                    <div class="ml-4 d-flex flex-wrap">
                                        @for (step of getQuestionCompletionSteps(q); track step.label) {
                                            <div class="mr-3 mb-1 d-flex align-items-center x-small text-success opacity-7">
                                                <mat-icon style="font-size: 12px; width:12px; height:12px;" class="mr-1">check_circle</mat-icon>
                                                <span>{{ step.label | translate }}{{ step.detail ? ': ' + step.detail : '' }}</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </div>
        }

        <!-- Detailed View: ONLY if NOT anonymous -->
        @if (!isAnonymous) {
            <app-survey-details [surveyObj]="survey" [isResponse]="true" />
        }
      </div>
    }
  </div>
</div>
}
